import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'
const bc = 'info-block'

const InfoBlock = ({ children }) => <div className={bc}>{children}</div>

InfoBlock.propTypes = {
  children: PropTypes.node.isRequired,
}

export default InfoBlock
